import React, { useState } from 'react';

import RenderIf from 'components/RenderIf';
import CustomProgress from 'modules/auth/components/CustomProgress';
import { Helmet } from 'react-helmet-async';

import Table from '../home/components/VoidTicketsTable';
import Barcode from '../home/modals/Barcode';

export default function Tickets() {
  const [isLoading, setIsLoading] = useState(true);
  const [showBarcode, setShowBarcode] = useState(false);
  const [ticketInformation, setTicketInformation] = useState({});

  return (
    <React.Fragment>
      <Helmet>
        <title>Bron edilmiş kuponlar | 1x2</title>
        <meta name="description" content="Bron edilmiş kuponlar | 1x2" />
      </Helmet>
      <div className="my-tickets">
        <div className="container my-tickets__container">
          <div className="my-tickets__title">
            <span>Bron edilmiş kuponlar</span>
          </div>

          <div className="wrapper-table">
            <Table
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setShowBarcode={setShowBarcode}
              setTicketInformation={setTicketInformation}
            />
          </div>
        </div>
      </div>
      <RenderIf condition={isLoading}>
        <CustomProgress />
      </RenderIf>
      <RenderIf condition={showBarcode}>
        <Barcode
          show={showBarcode}
          onHide={setShowBarcode}
          ticketInformation={ticketInformation}
          url="voidTickets"
          enablePrint
        />
      </RenderIf>
    </React.Fragment>
  );
}
